@if (entry.base?.display) {
  <!-- Houses dynamically updated stringified data-->
  <!-- <form [formGroup]="form" [connect]="'payloadStates.' + entry?.formControlAttributes.connectPath"></form>
  <form [formGroup]="marketplacePaymentOptionsForm" (ngSubmit)="submit()" class="form-container" *ngIf="marketplacePaymentOptionsForm">
    <h2>Payment Preferences</h2>
    <h3>Choose how you want to pay</h3>
    <mat-radio-group formControlName="selectedPaymentType">
      <span>Please select a payment option from the list below.</span>
      <ng-container *ngFor="let option of paymentOptions; trackBy: trackByIndex; let i = index">
        <mat-radio-button [value]="option.value">
          <span>{{ option.label }}</span>
        </mat-radio-button>
        <p [innerHTML]="option.description"></p>
        <hr/>
      </ng-container>
    </mat-radio-group>
    <div>
      <button mat-raised-button color="primary" type="submit">Next</button>
    </div>
  </form> -->
}

<div class="marketplace-payment-redirect">
  <h3>
    In order to process the first payment of your premium you will be sent to the Healthcare Marketplace.
    <br />
    Please follow the steps outlined, below, in order to navigate to the payment page.
  </h3>

  <p>Upon redirection to the Marketplace you will be required to <strong>login (using your Marketplace
  credentials)</strong>
</p>
<img src="{{imageUrls.login}}" />

<p>
  After logging in, you will be prompted to continue to the applications, disregard the date, and proceed via
  <strong>'CONTINUE'</strong>.
</p>
<img src="{{imageUrls.continue}}" />

<p>You will see a list with your active application(s), select your submitted application to access the payment
  redirect page.
</p>
<img src="{{imageUrls.appSelection}}" />

<p>Press the <strong>'PAY YOUR FIRST PREMIUM'</strong> button to access the payment form
</p>
<img src="{{imageUrls.premiumPayment}}" />

<div>
  <button (click)="goToMarketplacePayment()" mat-raised-button color="primary" type="button">
    Proceed to Marketplace for Payment Processing
  </button>
</div>
</div>